import { useEffect } from "react";
import { useBackendStatusContext } from "../context/backendStatus/backendStatusContext";
import {
  SET_BACKEND_STATUS_ERROR,
} from "../context/backendStatus/backendStatusActions";

const REBOOT_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

export default function useRebootMonitor() {
  const { state, dispatch } = useBackendStatusContext();

    useEffect(() => {
        const rebooting = localStorage.getItem("sonda.backend.rebooting") === "true";

        if (!rebooting) return;

        const timeout = setTimeout(() => {
            // If still rebooting after timeout, assume failure
            if (state.status === "rebooting") {
                console.warn("Backend reboot timed out.");
                localStorage.removeItem("sonda.backend.rebooting");
                dispatch({ type: SET_BACKEND_STATUS_ERROR });
            }
        }, REBOOT_TIMEOUT_MS);

        return () => clearTimeout(timeout);
    }, [state.status, dispatch]);
};